import ReinstateWarrantyDialogContainer from "./reinstateWarrantyDialog.container";

export default ReinstateWarrantyDialogContainer;
